/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import * as Sentry from "@sentry/react";
import { Box, Typography, Grid } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
// import { css } from "@emotion/react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ORGANIZATION_STRUCTURE_FIELDS } from "../../../../../contants/formFields";
import Styles from "./style";
import IntroductionFormApi from "../../../../../services/api/introductionForm";
import { getOptions } from "../../../../../utils";
import { isEmptyObj } from "../../../../../utils/helper";
import { OS_REDUX_KEY_MAPPER, PERMISSIONS } from "../../../../../contants";
import { SET_ORGANISATION_STRUCTURE } from "../../../../../redux/actionTypes/meta";
import AutoCompleteDropdown from "../../AutoCompleteDropdown/AutoCompleteDropdown";
import Colors from "../../../../../theme/colors";
import ZoneLocator from "../../../OrganizationStructure/ZoneLocator/ZoneLocator";
import useUserConfig from "../../../../../hooks/useUserConfig";

// const gridItemStyle = css`
//   @media (max-width: 768px) {
//     grid-column: 1 / 3;
//   }
// `;

function NewOrganization({
  values,
  errors,
  setFieldValue,
  // required,
  useHiddenInput,
  storeValuesInRedux,
  shouldFetchOtherOS,
  disabledOSKeys,
  showBlock,
  showZoneLocator,
  isChapterSi,
  cameFromFriendTransfer,
  cameFromMemberTransfer,
}) {
  const [areaData, setAreadData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [isZoneLocatorOpen, setIsZoneLocatorOpen] = useState(false);
  const dispatch = useDispatch();
  const formRequestRef = useRef(true);

  const hasPermission = useUserConfig();

  const openZoneLocator = () => {
    setIsZoneLocatorOpen(true);
  };

  const getData = async (api, setState, params, setter) => {
    try {
      let response;
      if (params) {
        response = await api({ data: params });
      } else {
        response = await api({});
      }
      setState(response?.data || response || []);
      if (setter) {
        setter();
      }
      if (storeValuesInRedux) {
        const key = isEmptyObj(params)
          ? "areas"
          : OS_REDUX_KEY_MAPPER[Object.keys(params)[0]];

        dispatch({
          type: SET_ORGANISATION_STRUCTURE,
          payload: {
            [key]: response?.data,
          },
        });
      }
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const handleZoneLocationSelection = (selectedZoneData) => {
    setRegionData([]);
    setChapterData([]);
    setDistrictData([]);
    setBlockData([]);
    setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
    setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
    setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
    setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");

    setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.AREA, selectedZoneData.areaId);

    if (selectedZoneData.areaId) {
      getData(
        IntroductionFormApi.getAllZones,
        setZoneData,
        {
          areaId: selectedZoneData.areaId,
        },
        () =>
          setFieldValue(
            ORGANIZATION_STRUCTURE_FIELDS.ZONE,
            selectedZoneData.zoneId
          )
      );
    }

    if (selectedZoneData.zoneId) {
      getData(IntroductionFormApi.getAllRegions, setRegionData, {
        zoneId: selectedZoneData.zoneId,
      });
    }

    setIsZoneLocatorOpen(false);
  };

  const fetchAllOtherOS = () => {
    if (values.areaId) {
      getData(IntroductionFormApi.getAllZones, setZoneData, {
        areaId: values.areaId,
      });
    }
    if (values.zoneId) {
      getData(IntroductionFormApi.getAllRegions, setRegionData, {
        zoneId: values.zoneId,
      });
    }
    if (values.regionId) {
      getData(IntroductionFormApi.getAllChapters, setChapterData, {
        regionId: values.regionId,
      });
    }
    if (values.chapterId) {
      getData(IntroductionFormApi.getAllDistricts, setDistrictData, {
        chapterId: values.chapterId,
      });
    }
    if (values.districtId) {
      getData(IntroductionFormApi.getAllBlocks, setBlockData, {
        districtId: values.districtId,
      });
    }
  };
  useEffect(() => {
    getData(IntroductionFormApi.getAllArea, setAreadData);
    fetchAllOtherOS();
  }, []);

  useEffect(() => {
    if (shouldFetchOtherOS && formRequestRef.current) {
      fetchAllOtherOS();
      formRequestRef.current = false;
    }
  }, [values, shouldFetchOtherOS]);

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div style={{ display: "flex", flexDirection: "row", justifyItem: "left" }}>
      <div style={Styles.gridContainer}>
        <Grid
          style={
            isMobile
              ? { width: "100%" }
              : { ...Styles.gridItem, ...Styles.inputField }
          }
          // sx={gridItemStyle}
        >
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Area"
            name={ORGANIZATION_STRUCTURE_FIELDS.AREA}
            options={getOptions(areaData, "structureId")}
            error={errors[ORGANIZATION_STRUCTURE_FIELDS.AREA]}
            value={values[ORGANIZATION_STRUCTURE_FIELDS.AREA]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.AREA, "");
              } else {
                setFieldValue(
                  ORGANIZATION_STRUCTURE_FIELDS.AREA,
                  selectedValue.value
                );
                getData(IntroductionFormApi.getAllZones, setZoneData, {
                  areaId: selectedValue.value,
                });
              }
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.ZONE, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
              setZoneData([]);
              setRegionData([]);
              setChapterData([]);
              setDistrictData([]);
              if (showBlock) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setBlockData([]);
              }
            }}
            useHiddenInput={useHiddenInput}
            disabled={
              disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.AREA) ||
              ((cameFromFriendTransfer || cameFromMemberTransfer) &&
                isChapterSi)
            }
          />
        </Grid>
        <Grid
          style={
            isMobile
              ? { width: "100%" }
              : { ...Styles.inputField, ...Styles.gridItem }
          }
          // sx={gridItemStyle}
        >
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Zone"
            name={ORGANIZATION_STRUCTURE_FIELDS.ZONE}
            options={getOptions(zoneData, "structureId")}
            error={errors[ORGANIZATION_STRUCTURE_FIELDS.ZONE]}
            value={values[ORGANIZATION_STRUCTURE_FIELDS.ZONE]}
            disabled={
              !values[ORGANIZATION_STRUCTURE_FIELDS.AREA] ||
              disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.ZONE) ||
              ((cameFromFriendTransfer || cameFromMemberTransfer) &&
                isChapterSi)
            }
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.ZONE, "");
              } else {
                setFieldValue(
                  ORGANIZATION_STRUCTURE_FIELDS.ZONE,
                  selectedValue.value
                );
                getData(IntroductionFormApi.getAllRegions, setRegionData, {
                  zoneId: selectedValue.value,
                });
              }
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
              setRegionData([]);
              setChapterData([]);
              setDistrictData([]);
              if (showBlock) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setBlockData([]);
              }
            }}
            useHiddenInput={useHiddenInput}
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Region"
            name={ORGANIZATION_STRUCTURE_FIELDS.REGION}
            options={getOptions(regionData, "structureId")}
            error={errors[ORGANIZATION_STRUCTURE_FIELDS.REGION]}
            disabled={
              !values[ORGANIZATION_STRUCTURE_FIELDS.ZONE] ||
              disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.REGION)
            }
            value={values[ORGANIZATION_STRUCTURE_FIELDS.REGION]}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
              } else {
                setFieldValue(
                  ORGANIZATION_STRUCTURE_FIELDS.REGION,
                  selectedValue.value
                );
                getData(IntroductionFormApi.getAllChapters, setChapterData, {
                  regionId: selectedValue.value,
                });
              }
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
              setChapterData([]);
              setDistrictData([]);
              if (showBlock) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setBlockData([]);
              }
            }}
            useHiddenInput={useHiddenInput}
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Chapter"
            name={ORGANIZATION_STRUCTURE_FIELDS.CHAPTER}
            options={getOptions(chapterData, "structureId")}
            error={errors[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]}
            value={values[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]}
            disabled={
              !values[ORGANIZATION_STRUCTURE_FIELDS.REGION] ||
              disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER)
            }
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
              } else {
                setFieldValue(
                  ORGANIZATION_STRUCTURE_FIELDS.CHAPTER,
                  selectedValue.value
                );
                getData(IntroductionFormApi.getAllDistricts, setDistrictData, {
                  chapterId: selectedValue.value,
                });
              }
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
              setDistrictData([]);
              if (showBlock) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setBlockData([]);
              }
            }}
            useHiddenInput={useHiddenInput}
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="District"
            name={ORGANIZATION_STRUCTURE_FIELDS.DISTRICT}
            options={getOptions(districtData, "structureId")}
            error={errors[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
            value={values[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
            disabled={
              !values[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER] ||
              disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT)
            }
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
              } else {
                setFieldValue(
                  ORGANIZATION_STRUCTURE_FIELDS.DISTRICT,
                  selectedValue.value
                );
                if (showBlock) {
                  getData(IntroductionFormApi.getAllBlocks, setBlockData, {
                    districtId: selectedValue.value,
                  });
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                  setBlockData([]);
                }
              }
            }}
            useHiddenInput={useHiddenInput}
          />
        </Grid>
        <Grid style={Styles.gridItem}>
          {hasPermission(PERMISSIONS.SHOW_ZONELOCATOR_INTRODUCTION) &&
            hasPermission(PERMISSIONS.SHOW_ZONELOCATOR_FRIEND) &&
            hasPermission(PERMISSIONS.SHOW_ZONELOCATOR_MEMBER) &&
            showZoneLocator && (
              <Box
                sx={{
                  borderBottom: "2px solid #003E99",
                  "&:hover": { borderBottom: "2px solid #0054CC" },
                  width: isMobile ? "120px" : "",
                }}
                onClick={openZoneLocator}
              >
                <Typography
                  sx={{
                    color: Colors.midnightBlue,
                    "&:hover": {
                      color: Colors.hoverBlue,
                    },
                    ...Styles.zoneLocatorContainer,

                    alignItems: "center",
                    fontSize: "18px",
                    fontWeight: 600,
                  }}
                >
                  Zone Locator
                  <LaunchIcon
                    sx={{
                      color: Colors.midnightBlue,
                      "&:hover": {
                        color: Colors.hoverBlue,
                      },
                      marginLeft: 5,
                      fontSize: 20,
                    }}
                  />
                </Typography>
              </Box>
            )}
          {showBlock && (
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Block"
              name={ORGANIZATION_STRUCTURE_FIELDS.BLOCK}
              options={getOptions(blockData, "structureId")}
              error={errors[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
              value={values[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
              disabled={
                !values[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT] ||
                disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.BLOCK)
              }
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                } else {
                  setFieldValue(
                    ORGANIZATION_STRUCTURE_FIELDS.BLOCK,
                    selectedValue.value
                  );
                }
              }}
              useHiddenInput={useHiddenInput}
            />
          )}
          {isZoneLocatorOpen ? (
            <ZoneLocator
              handleClose={() => {
                setIsZoneLocatorOpen(false);
              }}
              handleSelectedOption={handleZoneLocationSelection}
            />
          ) : null}
        </Grid>
        <div style={Styles.gridItem} />
      </div>
    </div>
  );
}
const propTypes = {
  disabledOSKeys: PropTypes.arrayOf(PropTypes.string),
  // eslint-disable-next-line react/require-default-props
};

const defaultProps = {
  //   useHiddenInput: false,

  disabledOSKeys: [],
};

NewOrganization.propTypes = propTypes;
NewOrganization.defaultProps = defaultProps;

export default NewOrganization;
